module.exports = __webpack_public_path__ + "img/rule50.png";